import { render } from "./TablePager.vue?vue&type=template&id=3de4bc45&ts=true"
import script from "./TablePager.vue?vue&type=script&lang=ts"
export * from "./TablePager.vue?vue&type=script&lang=ts"

import "./TablePager.vue?vue&type=style&index=0&id=3de4bc45&lang=scss"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TablePager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3de4bc45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3de4bc45', __exports__)) {
    api.reload('3de4bc45', __exports__)
  }
  
  module.hot.accept("./TablePager.vue?vue&type=template&id=3de4bc45&ts=true", () => {
    api.rerender('3de4bc45', render)
  })

}


export default __exports__